import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import {
    getTaskData,
    postComment,
    updateComment,
    openModal,
    createTodo,
    registerHistory,
    changeTitle,
	setOnboardingStep,
    closeTask
} from 'state/actions'

import { DragDropContext } from 'react-beautiful-dnd'

import MainHeaderNav from 'sections/main-header-nav'

import MessageList from 'components/message-list/message-list'

import {
    forIn
} from 'lodash'

import copy from 'fast-copy'

import Loader from 'components/loader/loader'
import Button from 'components/button/button'
import Dateprogress from 'components/date-progress/date-progress'

import ProjectBreadcrumbs from '../../project-breadcrumbs'

import SingleTaskInfo from './single-task-info'
import SingleTaskFiles from './single-task-files'
import SingleTaskCheckList from './single-task-checklist'
import SingleTaskTiming from './single-task-timing'

import withValidateResponse from 'components/validations/withValidateResponse'

import DropZoneIndicator from 'components/drop-zone-indicator/drop-zone-indicator'

import {
    stringIsEmpty,
    getMentionableUsers,
    getMentionIdsFromComment,
    isMobile,
    isTaskInTodos,
    scrollToTop,
    parseFileArray,
    eventContainsFiles,
    scaleFactor,
    getPrimaryColumnValue,
    getMobileOperatingSystem
} from 'utils'

import {
    getCurrentAccount,
    getCurrentUser,
    getTaskUploads
} from 'state/selectors'

import MobileSubMenu from 'components/mobile/mobile-sub-menu'

import QuillWysiwyg from 'components/input/quill-wysiwyg'

import Scroll from 'react-scroll'

class SingleTask extends Component {
    state = {
        userMentions: getMentionableUsers(this.props.applicableUsers),
        currentOpenColumnId: null,
        currentFocusedTask: parseInt(this.props.taskId),
        pendingComments: [],
        currentTab: 0,
        commentInputText: '',
        isDraggingFileOver: false,
        repliedComment: null,
        isLoading: true,
        keyboardHeight: 0
    }

    os = getMobileOperatingSystem()
    scroll = Scroll.animateScroll

    usersArray = []
    taskObject = null

    openMenu = type => {
        this.setState({
            currentOpenColumnId: type,
        })
    }

    componentWillMount() {
        window.requestAnimationFrame(() => {
            this.tryGetTaskData()
        })

        if (isMobile() && this.os !== 'Android') {
            window.addEventListener('keyboardWillShow', this.keyboardHeightChanged)
            window.addEventListener('keyboardWillHide', this.keyboardHeightChanged)
            window.addEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
        }
    }

    componentWillUnmount() {
        if (isMobile() && this.os !== 'Android') {
            window.removeEventListener('keyboardWillShow', this.keyboardHeightChanged)
            window.removeEventListener('keyboardWillHide', this.keyboardHeightChanged)
            window.removeEventListener('keyboardHeightWillChange', this.updateKeyboardHeight)
        }

        const { currentTaskId, taskId, closeTask } = this.props

        if(currentTaskId === taskId){
		    closeTask()
        }
    }

    keyboardHeightChanged = e => {
        this.setState({
            keyboardHeight: e.keyboardHeight ? (e.keyboardHeight * scaleFactor()) : 0
        }, _ => {
            window.requestAnimationFrame(_ => {
                this.scroll.scrollToBottom({
                    duration: 100,
                    delay: 1,
                    smooth: "easeInOutQuint",
                })
            })
        })
    }

    componentDidMount = _ => {
        if (this.props.currentTask) {
            this.props.changeTitle(this.props.currentTask.name)
        }

        // removing this timeout breaks the tab transition, for some reason.
        setTimeout(_ => {
            if (isMobile() && this.containerRef) {
                setTimeout(_ => {
                    if (this.containerRef) {
                        const offsetFromTop = this.containerRef.getBoundingClientRect().top

                        this.setState({
                            offsetFromTop
                        })
                    }
                }, 1000)
            }
        }, 1)
    }

    componentWillUpdate = nextProps => {
        const {
            currentTask,
            match,
            hasHardSetState,
            changeTitle,
            applicableUsers,
            history
        } = this.props

        const oldTask = currentTask
        const newTask = nextProps.currentTask

        if (!hasHardSetState && nextProps.hasHardSetState) {
            this.tryGetTaskData()
        }

        // If the task's been deleted/archived, get outta here (mainly for mobile)
        if (oldTask && newTask) {
            if (this.state.pendingComments.length) {
                if (!newTask.comments || !oldTask.comments || oldTask.comments.length !== newTask.comments.length) {
                    this.setState({
                        pendingComments: []
                    })
                }
            }

            if (!oldTask.deleted_at && newTask.deleted_at && oldTask.id === newTask.id) {
                const parentUrl = match.path.replace(':task_id', '')
                history.push(parentUrl)
            }
        }

        if (!oldTask && newTask || (oldTask && newTask && oldTask.id !== newTask.id)) {
            changeTitle(nextProps.currentTask.name)
        }

        if (applicableUsers !== nextProps.applicableUsers) {
            this.setState({
                userMentions: getMentionableUsers(nextProps.applicableUsers)
            })
        }
    }

    componentDidUpdate = prevProps => {
        if (this.props.taskId !== prevProps.taskId) {
            this.tryGetTaskData(this.props.taskId)
        }
    }

    shouldComponentUpdate = nextProps => {
        if (this.props.modal.operation || nextProps.modal.operation) {
            if (this.props.modal.operation && !nextProps.modal.operation) {
                return true
            }

            return false
        }

        return true
    }

    tryGetTaskData = newTaskId => {
        const {
            registerHistory,
            getTaskData,
            openModal,
            history,
            taskId: _taskId
        } = this.props

        const taskId = _taskId || newTaskId

        registerHistory(taskId, 'task')

        getTaskData(parseInt(taskId), isError => {
            if (isError) {
                openModal('error', null, { message: 'This task couldn\'t be opened.' })

                const parentUrl = this.props.match.path.replace(':task_id', '')

                return history.push(parentUrl)
            }

            if (this.state.isLoading) {
                this.setState({
                    isLoading: false
                })
            }
        })
    }

    postComment = _ => {
        const {
            userData,
            postComment,
            allTasks,
            setOnboardingStep,
            taskId
        } = this.props

        const {
            repliedComment,
            commentInputText
        } = this.state

        let comment = commentInputText

        const mentionIds = getMentionIdsFromComment(comment)

        const task = allTasks[taskId]

        if (!comment) {
            return
        }

        comment = comment.replace(/target="_self"/g, 'target="_blank"')

        postComment(comment, mentionIds, userData, task, repliedComment)


	    setOnboardingStep('POSTED_COMMENT', userData)

        const pendingComments = copy(this.state.pendingComments)

        if (!repliedComment) {
            pendingComments.push(comment)
        }

        this.setState({
            pendingComments,
            commentInputText: '',
            repliedComment: null
        })
    }

    uploadFile = versions => {
        let modalData = {
            task: this.props.currentTask,
            file: null,
            versions,
            project_id: this.props.currentProjectId,
            uploaded_to_task: true
        }

        this.props.openModal('upload', 'task_file', modalData)
    }

    goBack = _ => {
        let tempUrl = this.props.match.path
        var to = tempUrl.lastIndexOf('/')
        to = to == -1 ? tempUrl.length : to + 1
        tempUrl = tempUrl.substring(0, to)

        this.props.history.push(tempUrl)
    }

    handleKeyPress = e => {
        if (e.key === 'Enter') {
            this.handleReturn(e)
        }
    }

    handleReturn = e => {
        if (navigator.platform.indexOf('Win') > -1) {
            if (e.ctrlKey) {
                this.postComment()
                return 'handled'
            }
        } else if (navigator.platform.indexOf('Mac') > -1) {
            if (e.metaKey) {
                this.postComment()
                return 'handled'
            }
        }

        return 'not-handled'
    }


    toggleTabs = tab => {
        this.setState({
            currentTab: tab
        })
    }

    openFile = fileId => {
        const currentUrl = this.props.match.url
        let urlSegments = currentUrl.split('/')

        urlSegments.length = 4

        let newUrl = urlSegments.join('/')

        newUrl += '/files/' + fileId

        this.props.history.push(newUrl)
    }

    deleteFile = file => {
        this.props.openModal('delete', 'file', { data: file })
    }

    consolidateFilesAndVersions = _ => {
        const {
            allFiles,
            uploads
        } = this.props

        let filesArray = []

        uploads.files.forEach(file => {
            if (!file.deleted_at) {
                filesArray.push(file)
            }
        })

        uploads.versions.forEach(version => {
            const file = allFiles[version.file_id]

            if (!file || file.deleted_at) {
                return
            }

            if (!file.latestVersion) {
                return
            }

            let isFileInArray = false

            filesArray.forEach(existingFile => {
                if (existingFile.id === file.id) {
                    isFileInArray = true
                }
            })

            if (!isFileInArray) {
                filesArray.push(file)
            }
        })

        filesArray.sort(function (a, b) {
            return a.created_at.localeCompare(b.created_at)
        })

        filesArray.reverse()

        return [...filesArray]
    }

    updateComment = comment => {
        this.props.updateComment(comment)
    }

    deleteComment = comment => {
        this.props.openModal('delete', 'comment', comment)
    }

    handleChange = value => {
        const valueWithoutStyleTags = value.replace(/style="[a-zA-Z0-9:;\.\s\(\)\-\,]*"/gi, '')

        if (this.props.setIsInputDirty) {
            this.props.setIsInputDirty(!stringIsEmpty(valueWithoutStyleTags))
        }

        this.setState({
            commentInputText: valueWithoutStyleTags
        })
    }

    deleteTask = _ => {
        this.props.openModal('delete', 'task', {
            data: this.props.currentTask,
        })
    }

    isCommentTextEmpty = _ => {
        const commentText = this.state.commentInputText

        return stringIsEmpty(commentText)
    }

    handleDrop = e => {
        e.preventDefault()
        e.stopPropagation()

        const dt = e.dataTransfer
        const files = dt.files

        const fileArray = []

        if (files) {
            forIn(files, file => {
                if (typeof file == 'object') {
                    fileArray.push(file)
                }
            })
        }

        if (fileArray) {
            parseFileArray(fileArray, this.uploadFile)
        }

        this.setState({
            isDraggingFileOver: false
        })
    }

    handleDragOver = (e, isLeave = false) => {
        e.preventDefault()
        e.stopPropagation()

        if (!isLeave) {
            if (eventContainsFiles(e) && !this.state.isDraggingFileOver) {
                this.setState({
                    isDraggingFileOver: true
                })
            }
        } else {
            this.setState({
                isDraggingFileOver: false
            })
        }
    }

    focusTextInput = _ => {
        if (this.inputRef) {
            if (this.inputRef.focusEditor) {
                this.inputRef.focusEditor()
            } else {
                this.inputRef.htmlEl.focus()
            }
        }
    }

    replyComment = message => {
        this.setState({
            repliedComment: message
        })

        this.focusTextInput()
    }

    cancelReplyComment = _ => {
        this.setState({
            repliedComment: null
        })
    }

    getChecklistItems = _ => {
        const {
            allChecklistItems,
        } = this.props

        const items = []

        if (this.taskObject.checklist_items) {
            this.taskObject.checklist_items.forEach(itemId => {
                const item = allChecklistItems[itemId]

                if (item && !item.deleted_at) {
                    items.push(item)
                }
            })
        }

        return items
    }

    openRecurringModal = _ => {
        const {
            openModal,
        } = this.props

        openModal('recur', 'task', { task: this.taskObject })
    }

    render() {
        const {
            userData,
            loading,
            allTasks,
            currentProject,
            currentAccount,
            allMilestones,
            todoDays,
            allTodoDays,
            allTodos,
            allUsers,
            allSessions,
            createTodo,
            openModal,
            applicableUsers,
            taskId
        } = this.props

        const {
            currentTab,
            pendingComments,
            commentInputText,
            userMentions,
            offsetFromTop,
            isDraggingFileOver,
            repliedComment,
            isLoading,
            keyboardHeight
        } = this.state

        const _isMobile = isMobile()

        this.usersArray = currentAccount ? currentAccount.users.map(userId => {
            return allUsers[userId] || null
        }).filter(Boolean) : []

        if (!taskId || !allTasks || !allTasks[taskId]) {
            return (
                <Loader visible={loading} />
            )
        }

        this.taskObject = allTasks[taskId]

        const isProjectEditable = !currentProject.deleted_at
        const filesInReverse = this.consolidateFilesAndVersions()
        const isArchived = !!this.taskObject.deleted_at
        const checklistItems = this.getChecklistItems()

        let sideTabs = [(
            <SingleTaskInfo
                menuState={this.state}
                currentTab={_isMobile ? 0 : currentTab}
                isArchived={isArchived}
                isPremium={true}
                taskObject={this.taskObject}
                applicableUsers={applicableUsers}
                openMenu={this.openMenu}
                allUsers={allUsers}
                hasGantts={currentProject.has_gantts}
                isProjectEditable={isProjectEditable}
                currentProject={currentProject}
            />
        )]

        if (_isMobile) {
            this.navtabs = [
                {
                    name: 'Comments',
                    path: 'comments',
                    isActive: !currentTab,
                    callback: _ => {
                        this.toggleTabs(0)
                    }
                }, {
                    name: 'Task info',
                    path: 'info',
                    isActive: currentTab == 1,
                    callback: _ => {
                        this.toggleTabs(1)
                    }
                }
            ]
        } else {
            const completedChecklistItems = checklistItems.filter(item => {
                return item.is_checked
            })

            this.navtabs = [
                {
                    name: 'Comments',
                    path: 'info',
                    icon: 'fe-mail'
                }, {
                    name: `Checklist${checklistItems.length ? ' (' + completedChecklistItems.length + '/' + checklistItems.length + ')' : ''}`,
                    path: 'check-list',
                    icon: 'fe-clipboard'
                }, {
                    name: 'Task info',
                    path: 'info',
                    icon: 'fe-info'
                }
            ]

            sideTabs = [
                null,
                (
                    <SingleTaskCheckList
                        taskObject={this.taskObject}
                        isProjectEditable={isProjectEditable}
                        checklistItems={checklistItems}
                        isArchived={isArchived}
                    />
                ),
                ...sideTabs
            ]

            if (currentProject.has_timing) {
                sideTabs.splice(1, 0, (
                    <SingleTaskTiming
                        currentTab={currentTab}
                        taskObject={this.taskObject}
                        allSessions={allSessions}
                        allUsers={allUsers}
                        isProjectEditable={isProjectEditable}
                    />
                ))

                this.navtabs.splice(1, 0, {
                    name: 'Timing',
                    path: 'time-tracking',
                    icon: 'fe-clock'
                })
            }

            if(filesInReverse.length){
                sideTabs.splice(1, 0, (
                    <SingleTaskFiles
                        openFile={this.openFile}
                        deleteFile={this.deleteFile}
                        filesInReverse={filesInReverse}
                        currentTab={currentTab}
                        openModal={openModal}
                        isProjectEditable={isProjectEditable}
                    />
                ))

                this.navtabs.splice(1, 0, {
                    name: `Files (${filesInReverse.length})`,
                    path: 'files',
                    icon: 'fe-paperclip'
                })
            }
        }

        const isInTodos = isTaskInTodos(this.taskObject, todoDays, allTodoDays, allTodos)

        const statusId = getPrimaryColumnValue('status', this.taskObject, currentProject)

        const mobilesubMenuOptions = [
            {
                icon: 'fe-refresh-cw',
                label: this.taskObject.is_recurring ? 'Edit recurrence' : 'Make recurring',
                callback: this.openRecurringModal
            },
            {
                icon: 'check-square-o',
                label: 'Add to my to-do',
                callback: _ => {
                    createTodo(null, null, _ => { }, this.taskObject.id)
                },
                disabled: (isInTodos || statusId === 3)
            },
            {
                icon: 'fe-edit-2',
                label: 'Edit name',
                callback: _ => {
                    openModal('edit', 'task', this.taskObject)
                }
            },
            {
                icon: 'fe-trash-2',
                label: this.taskObject.deleted_at ? 'Delete task' : 'Archive task',
                callback: _ => {
                    this.deleteTask()
                }
            },
        ]

        const commentsClassName = `single-task-comments ${ isDraggingFileOver ? 'dragging-file' : '' } ${ isLoading ? 'loading' : '' }`

        const taskDates = getPrimaryColumnValue('date', this.taskObject, currentProject)

        return (
            <DragDropContext onDragStart={_ => { }} onDragEnd={_ => { }}>
                <div className="single-task-container"
                    onClick={_ => { this.openMenu(null, null) }}
                    ref={ref => this.containerRef = ref}
                    style={offsetFromTop ? {
                        top: offsetFromTop + 'px'
                    } : null}
                >
                    <header className="main-header">
                        <h1>
                            {this.taskObject.name}
                        </h1>
                        <div className="sub-title-area">
                            {currentProject.folder_id && currentAccount.folders &&
                                <ProjectBreadcrumbs
                                    milestone={allMilestones[this.taskObject.milestone_id]}
                                    goBack={this.goBack}
                                    type="task"
                                    currentProject={currentProject}
                                    currentAccount={currentAccount}
                                />
                            }
                            {((taskDates.start || taskDates.end) && _isMobile) &&
                                <Dateprogress
                                    startDate={taskDates.start}
                                    endDate={taskDates.end}
                                />
                            }
                        </div>
                        {_isMobile &&
                            <React.Fragment>
                                <div className="button-area">
                                    <Button
                                        size="small"
                                        label="Go back"
                                        icon="angle-left"
                                        callback={this.goBack}
                                    />
                                </div>
                                <MobileSubMenu
                                    options={mobilesubMenuOptions}
                                />
                            </React.Fragment>
                        }
                        <MainHeaderNav
                            currentProject={currentProject}
                            right={true}
                            relUrl={null}
                            callback={(_, i) => { this.toggleTabs(i) }}
                            isActiveCheck={i => currentTab === i}
                            navtabs={this.navtabs}
                            type='buttons'
                            collapsesNames={!_isMobile}
                        />
                    </header>
                    <main className="clear">
                        {!currentTab ?
                            <div
                                className={commentsClassName}
                                onDrop={this.handleDrop}
                                onDragOver={this.handleDragOver}
                                onDragLeave={e => this.handleDragOver(e, true)}
                                style={{
                                    paddingBottom: keyboardHeight > 100 ? (keyboardHeight - 100) + 'px' : keyboardHeight + 'px'
                                }}
                            >
                                <Loader
                                    visible={isLoading}
                                    noText={true}
                                />
                                <DropZoneIndicator />
                                <MessageList
                                    pendingComments={pendingComments}
                                    type="comment"
                                    user={userData}
                                    messageObject={this.taskObject}
                                    deleteCallback={this.deleteComment}
                                    updateCallback={this.updateComment}
                                    replyEntity={this.replyComment}
                                    cancelReplyEntity={this.cancelReplyComment}
                                    repliedEntity={repliedComment}
                                    isLoading={isLoading}
                                />
                                {
                                    (!isArchived && isProjectEditable) ?
                                        <div>
                                            <QuillWysiwyg
                                                isVisible={true}
                                                value={commentInputText}
                                                onChange={this.handleChange}
                                                ref={ref => this.quillRef = ref}
                                                canCollaborate={false}
                                                objectId={this.taskObject.id}
                                                availableMentions={userMentions}
                                                canEdit={true}
                                                placeholder="Write a comment here."
                                                context="comment"
                                                onKeyPress={this.handleKeyPress}
                                            />
                                        </div>
                                        : null
                                }
                                {(!isArchived && isProjectEditable) ?
                                    <div className="comments-footer clear">
                                        <Button
                                            size={'big'}
                                            level={'high'}
                                            callback={this.postComment}
                                            label={'Post comment'}
                                            icon={'paper-plane-o'}
                                            disabled={this.isCommentTextEmpty()}
                                        />
                                        <Button
                                            size={'big'}
                                            level={'low'}
                                            callback={this.uploadFile}
                                            label={'Upload files'}
                                            icon={'fe-upload'}
                                            hasFile={true}
                                        />
                                    </div>
                                    : null}
                            </div>
                            : null}
                        {currentTab ?
                            <div className="single-task-meta">
                                <ul className="radio-toggle-tabs">
                                    {sideTabs.map((tab, index) => {
                                        let isActive = currentTab === index

                                        if (_isMobile) {
                                            isActive = !index
                                        }

                                        return (
                                            <li
                                                className={isActive ? 'active' : null}
                                                key={index}
                                            >
                                                { tab}
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            : null}
                    </main>
                </div>
            </DragDropContext>
        )
    }
}

const mapStateToProps = state => {
    return {
        hasHardSetState: state.account.hasHardSetState,
        allUsers: state.account.entities.users,
        allTasks: state.account.entities.tasks,
        allMilestones: state.account.entities.milestones,
        userData: getCurrentUser(state),
        currentTask: state.account.entities.tasks ? state.account.entities.tasks[state.account.currentTaskId] : null,
        currentTaskId: state.account.currentTaskId,
        uploads: getTaskUploads(state),
        allFiles: state.account.entities.files,
        currentAccount: getCurrentAccount(state),
        currentProjectId: state.account.currentProjectId,
        todoDays: state.account.entities.users ? state.account.entities.users[state.account.entities.users[state.auth.userId].id].todo_days : [],
        allTodoDays: state.account.entities.todo_days,
        allTodos: state.account.entities.todos,
        allSessions: state.account.entities.sessions,
        allChecklistItems: state.account.entities.checklist_items,
        modal: state.modal
    }
}

const SingleTaskWithValidationResponse = withValidateResponse(SingleTask)

export default withRouter(connect(mapStateToProps, {
    getTaskData,
    postComment,
    updateComment,
    openModal,
    createTodo,
    registerHistory,
    changeTitle,
	setOnboardingStep,
    closeTask
})(SingleTaskWithValidationResponse))


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/single-task/single-task.jsx